@import '../../themes/capsule.globals';

:host {
  display: block;

  --height: 24px;
  --width: 24px;

  --icon-color: currentColor;
  --icon-fill-color: currentColor;
  --icon-stroke-color: currentColor;

  width: var(--width);
  height: var(--height);

  .foreground-0 {
    fill: var(--cpsl-color-foreground-0);
    stop-color: var(--cpsl-color-foreground-0);
  }
  .accent-0 {
    fill: var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
    stop-color: var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
  }
}

:host div {
  display: flex;

  width: 100%;
  height: 100%;

  color: var(--icon-color);
}

:host svg {
  width: 100%;
  height: 100%;

  & .background-16 {
    fill: var(--cpsl-color-background-16);
  }

  & .foreground-0 {
    fill: var(--cpsl-color-foreground-0);
  }

  & .fill {
    fill: var(--icon-fill-color);
  }

  & .stroke {
    stroke: var(--icon-stroke-color);
  }
}

:host img {
  width: 100%;
  height: 100%;

  object-fit: contain;
}
